import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    // Only run on client side
    if (typeof window === 'undefined') return;
    // Initialize fbq function if it doesn't exist
    if (!window.fbq) {
      window.fbq = function () {
        window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = window.fbq;
      window.fbq.push = window.fbq;
      window.fbq.loaded = true;
      window.fbq.version = '2.0';
      window.fbq.queue = [];
    }
    // Create and inject the script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    // Initialize pixel after script loads
    script.onload = () => {
      if (window.fbq) {
        window.fbq('init', '1421502962259206');
        window.fbq('track', 'PageView');
        console.log('Meta Pixel initialized and PageView tracked');
      }
    };
    // Append script to document head
    document.head.appendChild(script);
    // Cleanup function
    return () => {
      // Remove script on unmount if needed
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);
  return <noscript data-id="element-42">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1421502962259206&ev=PageView&noscript=1" alt="" data-id="element-43" />
    </noscript>;
}